import { inject, observer } from 'mobx-react';
import { Component, ReactNode } from 'react';
import { PageProps } from '../../../constants';

export function withScreen<S = {}>(Children: Function) {
  @inject('routerStore', 'publicStore', 'modalStore', 'actionStore', 'waitQueueStore') @observer
  class ScreenComponent extends Component<PageProps, S> {
    child: ReactNode;

    page: any;

    constructor(props: PageProps, context: any) {
      super(props, context);

      if (props.cacheLifecycles?.didRecover) {
        props.cacheLifecycles?.didRecover(this.componentDidRecover);
      }

      this.child = (
        <Children
          {...this.props}
          onMount={(page: any) => {
            this.page = page;
            this.props.publicStore.setCurrentPage(page);
          }}
        />
      );
    }

    componentDidMount() {
      const { currentPage } = this.props.publicStore;
      currentPage?.onFirstOpenEvent && currentPage.onFirstOpenEvent();
    }

    componentWillUnmount() {
      delete this.child;
      this.child = null;
    }

    componentDidRecover = () => {
      this.props.publicStore.setCurrentPage(this.page);
      this.page.componentDidRecover && this.page.componentDidRecover();
    }

    render() {
      return this.child;
    }
  }
  return ScreenComponent;
}
